<script>
export default {
  name: 'MenuTitle',
  props: {
    show: {
      type: Boolean,
      default: () => true
    },
    label: {
      type: String,
      required: false,
      default: () => 'menu'
    }
  }
}
</script>

<template>
  <li class="hidden-folded padder m-t m-b-sm text-muted text-xs" v-if="show">
    <span>
      <slot>{{label}}</slot>
    </span>
  </li>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// MenuTitle.vue?2eeba250